/*eslint-disable*/
import { makeStyles } from '@material-ui/core/styles';
import backgroundLogo from '../../assets/background/BackgroundLogin.png';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  bg: {
    backgroundImage: `url(${backgroundLogo})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    minHeight: '100%',
    backgroundPosition: 'top left',
    [theme.breakpoints.down('xs')]: {

    },
    [theme.breakpoints.down('sm')]: {

    },
    [theme.breakpoints.up('sm')]: {

    },
    [theme.breakpoints.down('md')]: {

    },
    [theme.breakpoints.up('md')]: {

    },
  },
  buttonNonBorder: {
    backgroundColor: '#fff',
    color: '#024787',
    border: 'none',
    fontWeight: 500,
    '&:hover': {
      fontWeight: 900,
      border: 'none',
    }
  },
  margin: {
    margin: theme.spacing(1),
    width: '70%',
  },
  titleModal: {
    fontWeight: 'bold',
    fontSize: 24,
    textAlign: 'center',
    marginBottom: 20
  },
  divCentered: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
  paragraphModal: {
    fontWeight: 400,
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 20
  },
  altertModal: {
    fontWeight: 400,
    fontSize: 16,
    textAlign: 'center',
    // marginBottom: 20
  },
}));

export { useStyles };
